import { DumGlobalEventSubmissionListDto } from '@src/Api/generated-global-event';
import { TEventItem, TEventStatus, TEventType } from './MySubmission.interface';
const getStatusFromValue = (value: number): TEventStatus => {
  switch (value) {
    case 0:
      return 'draft';
    case 1:
      return 'rejected';
    case 2:
      return 'on-review';
    case 4:
      return 'uncovered';
    default:
      return 'approved';
  }
};
export const reformatEventItem = (
  list: Array<DumGlobalEventSubmissionListDto> | null | undefined
) => {
  return (
    list?.map((v) => {
      const eventName = v.name;
      let eventType: TEventType = 'dum';
      switch (v.product_type) {
        case 1:
          eventType = 'riftstorm';
          break;
        case 2:
          eventType = 'casefile';
          break;
        case 3:
          eventType = 'report';
          break;

        default:
          break;
      }
      const type = getStatusFromValue(v.status ?? 2);
      return {
        id: v.id,
        city: v.location?.locationName ?? '',
        lat: v.location?.latitude ?? 0,
        lan: v.location?.longitude ?? 0,
        eventName,
        eventDate: v.eventDate ?? '',
        anomalyRating: 0,
        type: eventType,
        status: type
      } as TEventItem;
    }) ?? []
  );
};
